import { SxProps, Typography, styled } from '@mui/material';

const Title = styled((props) => <Typography {...props} component="h3" />)(({
	color: 'text.primary',
	fontSize: 'var(--font-size-sm)',
	fontWeight: '800',
	textTransform: 'uppercase',
	marginBottom: '10px',
	textAlign: 'left',
}));

export const DpSEOTitle = ({ children, ...props }: { children: React.ReactNode; sx?: SxProps }) => (
	<Title {...props}>{children}</Title>
);
